export * from './TooltipDecorator';
export * from './TooltipDecorator.type';
